import { createContext, useContext } from 'react';

interface CollapsibleContextType {
    toggleExpanded: () => void;
    expanded?: boolean;
    disabled?: boolean;
}

export const CollapsibleContext = createContext<CollapsibleContextType>({} as CollapsibleContextType);

export const useCollapsibleContext = () => {
    const context = useContext(CollapsibleContext);
    if (context === undefined) {
        throw new Error('useCollapsibleContext must be used within a CollapsibleContextProvider');
    }
    return context;
};
